import { useMemo } from 'react'

import Alert from 'react-bootstrap/Alert'

import AuthService from '../../utilities/services/auth.service'
import { isAiReportAssistantEnabled } from './aiReportAssistant'
import { extractDateRangeFromBuilderFilters } from './aiPlanToReportBuilderForm'
import { resolvePeriodRanges } from './reportingOverviewUtils'

import AskForReportPanel from './AskForReportPanel'

import './askForReportSection.scss'

export default function AskForReportSection({
  onApplyPlan,
  mappingWarnings = [],
  filters = [],
}) {
  const enabled = isAiReportAssistantEnabled()
  const organization = AuthService.getOrg()?.[0]
  const organizationUuid = organization?.uuid || ''
  const organizationName = organization?.name || ''

  const filterDateRange = useMemo(
    () => extractDateRangeFromBuilderFilters(filters),
    [filters]
  )

  const reportPeriod = useMemo(() => {
    if (!organizationUuid) return null

    if (filterDateRange) {
      return {
        from: filterDateRange.from,
        to: filterDateRange.to,
        rangeLabel: filterDateRange.rangeLabel,
      }
    }

    const { currentStart, currentEnd } = resolvePeriodRanges('30d', null)
    return {
      from: currentStart.toISOString(),
      to: currentEnd.toISOString(),
      rangeLabel: null,
    }
  }, [organizationUuid, filterDateRange])

  if (!enabled || !organizationUuid || !onApplyPlan) {
    return null
  }

  return (
    <div
      className="ask-for-report-section"
      data-testid="ask-for-report-section"
    >
      {mappingWarnings.length ? (
        <Alert variant="warning" className="small py-2 mb-2">
          {mappingWarnings.map((warning) => (
            <div key={warning}>{warning}</div>
          ))}
        </Alert>
      ) : null}

      {reportPeriod ? (
        <div className="ask-for-report-section__actions">
          <AskForReportPanel
            organizationUuid={organizationUuid}
            organizationName={organizationName}
            from={reportPeriod.from}
            to={reportPeriod.to}
            rangeLabel={reportPeriod.rangeLabel}
            nested
            integrated
            onApplyToBuilder={async (plan, meta = {}) => {
              await onApplyPlan(
                {
                  ...plan,
                  from: plan.from || reportPeriod.from,
                  to: plan.to || reportPeriod.to,
                  rangeLabel: plan.rangeLabel || reportPeriod.rangeLabel,
                },
                meta
              )
            }}
          />
        </div>
      ) : null}
    </div>
  )
}
